// @ts-nocheck
/* ============================================================
   NOVE - Product Page Interactions (no dependencies)
   ============================================================ */
(function () {
  'use strict';

  /* -------- Accordions -------- */
  document.querySelectorAll('.pp-accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var controlsId = trigger.getAttribute('aria-controls');
      if (!controlsId) return;
      var panel = document.getElementById(controlsId);
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (!panel) return;
      if (!expanded) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    });
  });

  /* -------- Image carousel --------
     Slides (.pp-carousel-slide) and thumbnails ([data-pp-thumb]) are built in
     the same order for a given colour, so "the Nth visible thumb" always maps
     to "the Nth visible slide". Colour switching just toggles which slides /
     thumbs are hidden; the carousel then resets to index 0. */
  var carouselEl = document.getElementById('pp-carousel');
  var carouselTrack = document.getElementById('pp-carousel-track');
  var carouselPrev = document.getElementById('pp-carousel-prev');
  var carouselNext = document.getElementById('pp-carousel-next');
  var carouselDots = document.getElementById('pp-carousel-dots');
  var currentSlideIndex = 0;

  function ppVisible(nodeList) {
    return Array.prototype.filter.call(nodeList, function (el) { return !el.hidden; });
  }

  function ppGetVisibleSlides() {
    return carouselTrack ? ppVisible(carouselTrack.querySelectorAll('.pp-carousel-slide')) : [];
  }

  function ppGetVisibleThumbs() {
    return ppVisible(document.querySelectorAll('[data-pp-thumb]'));
  }

  function ppSetActiveThumbByIndex(index) {
    ppGetVisibleThumbs().forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
  }

  function ppRenderDots() {
    if (!carouselDots) return;
    var count = ppGetVisibleSlides().length;
    carouselDots.innerHTML = '';
    carouselDots.hidden = count < 2;
    if (carouselPrev) carouselPrev.hidden = count < 2;
    if (carouselNext) carouselNext.hidden = count < 2;
    for (var i = 0; i < count; i++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pp-carousel-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Show image ' + (idx + 1));
        dot.addEventListener('click', function () { ppGoToSlide(idx); });
        carouselDots.appendChild(dot);
      })(i);
    }
  }

  function ppGoToSlide(index, immediate) {
    if (!carouselTrack) return;
    var slides = ppGetVisibleSlides();
    if (!slides.length) return;
    currentSlideIndex = Math.max(0, Math.min(index, slides.length - 1));

    if (immediate) carouselTrack.classList.add('pp-no-transition');
    carouselTrack.style.transform = 'translateX(-' + (currentSlideIndex * 100) + '%)';
    if (immediate) {
      requestAnimationFrame(function () { carouselTrack.classList.remove('pp-no-transition'); });
    }

    if (carouselDots) {
      Array.prototype.forEach.call(carouselDots.children, function (dot, i) {
        dot.setAttribute('aria-selected', i === currentSlideIndex ? 'true' : 'false');
      });
    }
    if (carouselPrev) carouselPrev.disabled = currentSlideIndex === 0;
    if (carouselNext) carouselNext.disabled = currentSlideIndex === slides.length - 1;

    ppSetActiveThumbByIndex(currentSlideIndex);
  }

  function ppResetCarousel() {
    ppRenderDots();
    ppGoToSlide(0, true);
  }

  if (carouselPrev) carouselPrev.addEventListener('click', function () { ppGoToSlide(currentSlideIndex - 1); });
  if (carouselNext) carouselNext.addEventListener('click', function () { ppGoToSlide(currentSlideIndex + 1); });

  if (carouselEl && carouselTrack) {
    carouselEl.setAttribute('tabindex', '0');
    carouselEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') ppGoToSlide(currentSlideIndex - 1);
      if (e.key === 'ArrowRight') ppGoToSlide(currentSlideIndex + 1);
    });

    /* Swipe (touch) + drag (mouse) support. */
    var dragging = false, startX = 0, deltaX = 0;

    function dragStart(x) {
      dragging = true;
      startX = x;
      deltaX = 0;
      carouselTrack.classList.add('pp-no-transition');
    }
    function dragMove(x) {
      if (!dragging) return;
      deltaX = x - startX;
      carouselTrack.style.transform = 'translateX(calc(-' + (currentSlideIndex * 100) + '% + ' + deltaX + 'px))';
    }
    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      carouselTrack.classList.remove('pp-no-transition');
      var threshold = carouselEl.offsetWidth * 0.15;
      if (deltaX < -threshold) ppGoToSlide(currentSlideIndex + 1);
      else if (deltaX > threshold) ppGoToSlide(currentSlideIndex - 1);
      else ppGoToSlide(currentSlideIndex);
    }

    carouselEl.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
    carouselEl.addEventListener('touchmove', function (e) { dragMove(e.touches[0].clientX); }, { passive: true });
    carouselEl.addEventListener('touchend', dragEnd);

    carouselEl.addEventListener('mousedown', function (e) { dragStart(e.clientX); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (dragging) dragMove(e.clientX); });
    window.addEventListener('mouseup', dragEnd);
  }

  /* -------- Color swatches + variant gallery + sold-out state -------- */
  var colorNameEl = document.getElementById('pp-color-name');
  var soldoutPill = document.getElementById('pp-soldout-pill');
  var swatchEls = document.querySelectorAll('.pp-swatch');

  function ppCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /* The selected bundle — either one of the three cards or the bulk extender. */
  function getActiveOption() {
    return document.querySelector(
      '.pp-tier[aria-checked="true"], #pp-extender[aria-checked="true"]'
    );
  }

  /* Show only the gallery thumbnails + carousel slides tagged for the
     selected colour, then reset the carousel to the first (hero) slide. */
  function ppShowThumbsForColor(color) {
    document.querySelectorAll('[data-pp-thumb]').forEach(function (t) {
      var tc = t.getAttribute('data-color') || 'black';
      t.hidden = (tc !== color);
    });
    if (carouselTrack) {
      carouselTrack.querySelectorAll('.pp-carousel-slide').forEach(function (s) {
        var sc = s.getAttribute('data-color') || 'black';
        s.hidden = (sc !== color);
      });
    }
    ppResetCarousel();
  }

  /* Toggle the sold-out pill + Add-to-Cart button for the selected colour. */
  function ppApplyAvailability(color, available) {
    if (soldoutPill) {
      if (available) {
        soldoutPill.hidden = true;
      } else {
        soldoutPill.textContent = ppCapitalize(color) + ' keychain sold out.';
        soldoutPill.hidden = false;
      }
    }
    var cartBtn = document.getElementById('pp-add-to-cart');
    var cartLabel = document.getElementById('pp-cart-btn-label');
    if (!cartBtn) return;
    if (available) {
      cartBtn.disabled = false;
      cartBtn.classList.remove('is-soldout');
      /* Restore the tier-driven price label. */
      var act = getActiveOption();
      if (act && typeof selectTier === 'function') selectTier(act);
    } else {
      cartBtn.disabled = true;
      cartBtn.classList.add('is-soldout');
      if (cartLabel) cartLabel.textContent = 'Sold out';
    }
  }

  function ppSelectColor(btn) {
    swatchEls.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    btn.setAttribute('aria-pressed', 'true');
    var color = btn.dataset.color || 'black';
    var available = btn.dataset.available !== 'false';
    if (colorNameEl) colorNameEl.textContent = color.toUpperCase();
    ppShowThumbsForColor(color);
    /** @type {HTMLInputElement|null} */
    var variantInput = /** @type {HTMLInputElement|null} */ (document.getElementById('pp-variant-id'));
    if (btn.dataset.variantId && variantInput) variantInput.value = btn.dataset.variantId;
    ppApplyAvailability(color, available);
  }

  swatchEls.forEach(function (btn) {
    btn.addEventListener('click', function () { ppSelectColor(btn); });
  });

  /* -------- Pricing Tiers / Bundle Selection -------- */
  var tiers = document.querySelectorAll('.pp-tier');
  var extenderEl = document.getElementById('pp-extender');
  /* The three cards and the bulk extender are one radio group: exactly one is
     selected at a time, and each carries data-qty / data-price / data-compare. */
  var options = Array.prototype.slice.call(tiers);
  if (extenderEl) options.push(extenderEl);

  var priceCurrentEl = document.querySelector('.pp-price-current');
  var priceWasEl     = document.querySelector('.pp-price-was');
  var priceSaveEl    = document.querySelector('.pp-price-save');
  var cartLabelEl    = document.getElementById('pp-cart-btn-label');
  var navOrderBtn    = document.getElementById('cta-order');

  function fmtMoney(n) {
    return '$' + n.toFixed(2);
  }

  function selectTier(tier) {
    options.forEach(function (t) {
      var checked = (t === tier);
      t.setAttribute('aria-checked', checked ? 'true' : 'false');
      var input = t.querySelector('.pp-tier-input');
      if (input) input.checked = checked;
    });

    var qty     = parseInt(tier.getAttribute('data-qty'), 10) || 1;
    var price   = parseFloat(tier.getAttribute('data-price')) || 0;
    var compare = parseFloat(tier.getAttribute('data-compare')) || 0;
    var save    = Math.max(0, compare - price);

    // Update top price summary
    if (priceCurrentEl) priceCurrentEl.textContent = fmtMoney(price);
    if (priceWasEl) {
      if (save > 0) {
        priceWasEl.textContent = fmtMoney(compare);
        priceWasEl.style.display = '';
      } else {
        priceWasEl.style.display = 'none';
      }
    }
    if (priceSaveEl) {
      if (save > 0) {
        priceSaveEl.textContent = 'save ' + fmtMoney(save);
        priceSaveEl.style.display = '';
      } else {
        priceSaveEl.style.display = 'none';
      }
    }

    // Update CTA label — but keep "Sold out" if the selected colour is unavailable
    if (cartLabelEl) {
      var selSwatch = document.querySelector('.pp-swatch[aria-pressed="true"]');
      if (selSwatch && selSwatch.dataset.available === 'false') {
        cartLabelEl.textContent = 'Sold out';
      } else {
        cartLabelEl.textContent = 'Add ' + qty + ' to Cart — ' + fmtMoney(price);
      }
    }

    // Nav-bar Order button — static label (no per-unit pricing)
    if (navOrderBtn) {
      navOrderBtn.textContent = 'Buy Now';
    }
  }

  tiers.forEach(function (tier) {
    tier.addEventListener('click', function (e) {
      // Prevent the <label>'s default behavior firing twice
      if (e.target.tagName === 'INPUT') return;
      selectTier(tier);
    });
    // Keyboard support
    tier.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        selectTier(tier);
      }
    });
  });

  /* -------- Bulk extender: quantity stepper (4+ cases) -------- */
  if (extenderEl) {
    var extMin = parseInt(extenderEl.getAttribute('data-min'), 10) || 1;
    var extMax = parseInt(extenderEl.getAttribute('data-max'), 10) || extMin;
    var extFreeShip = parseFloat(extenderEl.getAttribute('data-free-ship')) || 0;
    var extQtyEl = document.getElementById('pp-qty-value');
    var extTotalEl = document.getElementById('pp-extender-total');
    var extPerEl = document.getElementById('pp-extender-per');
    var extShipEl = document.getElementById('pp-extender-ship');
    var singleTier = document.querySelector('.pp-tier-single');

    var extPrices = {};
    try {
      extPrices = JSON.parse(extenderEl.getAttribute('data-prices') || '{}');
    } catch (err) {
      extPrices = {};
    }

    /* Per-case price for a quantity. Quantities between two configured steps
       inherit the price of the highest step at or below them, so the merchant
       only has to list the points where the price actually changes. */
    function extPerCase(qty) {
      var best = null;
      Object.keys(extPrices).forEach(function (key) {
        var k = parseInt(key, 10);
        if (k <= qty && (best === null || k > best)) best = k;
      });
      return best === null ? 0 : parseFloat(extPrices[String(best)]) || 0;
    }

    function extRender(qty) {
      var per = extPerCase(qty);
      var total = per * qty;

      extenderEl.setAttribute('data-qty', String(qty));
      extenderEl.setAttribute('data-price', total.toFixed(2));

      /* Compare-at = paying the single-case price for every unit. */
      var singlePrice = singleTier ? parseFloat(singleTier.getAttribute('data-price')) || 0 : 0;
      extenderEl.setAttribute('data-compare', (singlePrice * qty).toFixed(2));

      if (extQtyEl) extQtyEl.textContent = String(qty);
      if (extTotalEl) extTotalEl.textContent = fmtMoney(total);
      if (extPerEl) extPerEl.textContent = fmtMoney(per) + ' per case';
      if (extShipEl) extShipEl.hidden = !(extFreeShip > 0 && total >= extFreeShip);

      /* Lock the stepper at the configured range — shoppers who want fewer
         than the minimum use the bundle cards above. */
      extenderEl.querySelectorAll('[data-pp-step]').forEach(function (b) {
        var step = parseInt(b.getAttribute('data-pp-step'), 10);
        b.disabled = (step < 0 && qty <= extMin) || (step > 0 && qty >= extMax);
      });

      /* If the extender is the active option, push the new numbers upward. */
      if (extenderEl.getAttribute('aria-checked') === 'true') selectTier(extenderEl);
    }

    extenderEl.querySelectorAll('[data-pp-step]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var step = parseInt(btn.getAttribute('data-pp-step'), 10) || 0;
        var current = parseInt(extenderEl.getAttribute('data-qty'), 10) || extMin;
        var next = Math.min(extMax, Math.max(extMin, current + step));
        /* Stepping is an act of choosing the bulk option. */
        selectTier(extenderEl);
        extRender(next);
      });
    });

    /* Clicking anywhere else on the row selects it without changing quantity. */
    extenderEl.addEventListener('click', function () { selectTier(extenderEl); });
    extenderEl.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        selectTier(extenderEl);
      }
    });

    extRender(extMin);
  }

  // Initialize the default selected tier on page load
  var initialActiveTier = document.querySelector('.pp-tier[aria-checked="true"]');
  if (initialActiveTier) {
    selectTier(initialActiveTier);
  }

  /* -------- Star rating link -> smooth scroll to the reviews section --------
     Which reviews block is on the page varies: the manual "Customer Reviews"
     section is currently disabled on both templates, leaving only the Judge.me
     carousel. Resolve whichever exists rather than hardcoding a dead anchor. */
  function findReviewsSection() {
    var selectors = [
      '#pp-reviews',
      '.jdgm-carousel-wrapper',
      '.jdgm-review-widget',
      '.jdgm-widget',
      '#judgeme_product_reviews'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  var reviewLink = document.querySelector('[data-pp-scroll-to-reviews]');
  if (reviewLink) {
    reviewLink.addEventListener('click', function (e) {
      var target = findReviewsSection();
      if (!target) return; /* nothing to scroll to — leave the href alone */
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Point the href at the real target too, so middle-click and keyboard
       navigation land in the right place instead of following a dead anchor.
       Judge.me renders late, so re-check once it has had time to mount. */
    setTimeout(function () {
      var target = findReviewsSection();
      if (!target) return;
      if (!target.id) target.id = 'nove-reviews-anchor';
      reviewLink.setAttribute('href', '#' + target.id);
    }, 1200);
  }

  /* -------- Gallery thumbnail click -> jump the carousel to that slide -------- */
  document.querySelectorAll('[data-pp-thumb]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var thumbs = ppGetVisibleThumbs();
      var idx = thumbs.indexOf(a);
      if (idx > -1) ppGoToSlide(idx);
    });
  });

  /* -------- Helper: find the cart-drawer section ID -------- */
  function getCartDrawerSectionId() {
    var cartItems = /** @type {HTMLElement|null} */ (document.querySelector('cart-items-component[data-drawer]'));
    return cartItems ? cartItems.dataset.sectionId : null;
  }

  /* -------- Helper: open the cart drawer -------- */
  /**
   * Opens the cart drawer, waiting for the custom element to be defined if needed.
   * cart-drawer.js loads as type="module" which executes AFTER deferred scripts,
   * so the custom element class may not be registered yet when this runs.
   */
  function openCartDrawer() {
    var el = document.querySelector('cart-drawer-component');
    if (!el) return;

    /* If the custom element is already upgraded, open immediately */
    if (typeof el.open === 'function') {
      el.open();
      return;
    }
    if (typeof el.showDialog === 'function') {
      el.showDialog();
      return;
    }

    /* Custom element not yet defined - wait for it, then open */
    customElements.whenDefined('cart-drawer-component').then(function () {
      /* After definition, the element is auto-upgraded by the browser */
      if (typeof el.open === 'function') {
        el.open();
      } else if (typeof el.showDialog === 'function') {
        el.showDialog();
      }
    });
  }

  /* -------- Add to Cart (AJAX) - opens side cart drawer -------- */
  /** @type {HTMLButtonElement|null} */
  var addToCartBtn = /** @type {HTMLButtonElement|null} */ (document.getElementById('pp-add-to-cart'));
  if (addToCartBtn) {
    var btn = addToCartBtn;
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      /* Never POST a sold-out colour to /cart/add.js — it 422s and looks broken. */
      var selSwatch = document.querySelector('.pp-swatch[aria-pressed="true"]');
      if (selSwatch && selSwatch.dataset.available === 'false') return;

      /** @type {HTMLInputElement|null} */
      var variantInput = /** @type {HTMLInputElement|null} */ (document.getElementById('pp-variant-id'));
      if (!variantInput) return;

      var variantId = parseInt(variantInput.value, 10);
      if (!variantId) return;
      var activeTier = getActiveOption();
      var quantity = activeTier ? parseInt(activeTier.getAttribute('data-qty'), 10) : 2;

      /* Determine which section to request so the drawer can update inline */
      var sectionId = getCartDrawerSectionId();
      var sectionsParam = sectionId ? '&sections=' + sectionId : '';

      var formBody =
        'id=' + variantId +
        '&quantity=' + quantity +
        sectionsParam;

      btn.disabled = true;
      var btnSpan = btn.querySelector('span');
      if (btnSpan) btnSpan.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: formBody
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function (response) {
          var successSpan = btn.querySelector('span');
          if (successSpan) successSpan.textContent = 'Added!';

          /* Extract the sections HTML that the theme needs to morph the drawer */
          var sections = response.sections || {};

          /*
           * Strategy: Fetch the full cart state, then dispatch the theme's
           * native cart:update event with proper section HTML so that
           * cart-items-component can morph the drawer contents.
           *
           * We open the drawer AFTER the morph is complete to avoid the
           * double-showDialog() race (auto-open + explicit open) that was
           * leaving the drawer non-interactive.
           */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              /* Update any visible cart-count badges in the header */
              var cartCountEls = document.querySelectorAll(
                '[data-cart-count], .cart-count, .cart-count-bubble span, .cart-bubble__text-count'
              );
              cartCountEls.forEach(function (el) {
                el.textContent = String(cart.item_count);
              });

              /* Dispatch the cart:update event with the section HTML.
                 cart-items-component will morph the drawer contents. */
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'nove-product-hero',
                  data: {
                    itemCount: cart.item_count,
                    source: 'nove-product',
                    variantId: String(variantId),
                    sections: sections
                  }
                }
              }));

              /* Open the drawer after a micro-delay so the DOM morph
                 from the event above finishes first. If auto-open
                 already opened it, showDialog()'s guard (dialog.open)
                 will make this a harmless no-op. */
              setTimeout(function () {
                openCartDrawer();
              }, 120);
            });

          setTimeout(function () {
            var currentActiveTier = getActiveOption();
            if (currentActiveTier) {
              selectTier(currentActiveTier);
            } else {
              var resetSpan = btn.querySelector('span');
              if (resetSpan) resetSpan.textContent = 'Add to Cart';
            }
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          var errSpan = btn.querySelector('span');
          if (errSpan) errSpan.textContent = 'Error - retry';
          btn.disabled = false;
          setTimeout(function () {
            var currentActiveTier = getActiveOption();
            if (currentActiveTier) {
              selectTier(currentActiveTier);
            } else {
              var retrySpan = btn.querySelector('span');
              if (retrySpan) retrySpan.textContent = 'Add to Cart';
            }
          }, 2000);
        });
    });
  }

  /* -------- Initialise the selected colour state --------
     The server renders the correct default (in-stock colour), but we run the
     same path on load so the pill, gallery filter and ATC button stay in sync
     even if the rendered default ever changes. This also triggers the
     carousel's own first render via ppShowThumbsForColor -> ppResetCarousel. */
  var ppInitialSwatch = document.querySelector('.pp-swatch[aria-pressed="true"]') || swatchEls[0];
  if (ppInitialSwatch) ppSelectColor(ppInitialSwatch);
})();

/* -------- Judge.me: show data-score in rating wrapper -------- */
(function () {
  var tries = 0;
  var iv = setInterval(function () {
    var rating = document.querySelector('.jdgm-all-reviews-rating');
    if (!rating && ++tries < 30) return;
    clearInterval(iv);
    if (!rating) return;
    var score = rating.getAttribute('data-score');
    var wrapper = document.querySelector('.jdgm-all-reviews-rating-wrapper');
    if (score && wrapper) {
      var el = document.createElement('span');
      el.className = 'pp-review-score';
      el.textContent = score;
      wrapper.prepend(el);
    }
  }, 200);
})();

(function () {
  var tries = 0;
  var iv = setInterval(function () {
    var wrapper = document.querySelector('.jdgm-carousel-wrapper');
    var scroller = wrapper && wrapper.querySelector('.jdgm-carousel__item-wrapper');
    var left = wrapper && wrapper.querySelector('.jdgm-carousel__left-arrow');
    var right = wrapper && wrapper.querySelector('.jdgm-carousel__right-arrow');

    if ((!scroller || !left || !right) && ++tries < 30) return;
    clearInterval(iv);
    if (!scroller || !left || !right || scroller.dataset.noveReviewsReady === 'true') return;

    scroller.dataset.noveReviewsReady = 'true';
    left.setAttribute('role', 'button');
    right.setAttribute('role', 'button');
    left.setAttribute('tabindex', '0');
    right.setAttribute('tabindex', '0');
    left.setAttribute('aria-label', 'Previous reviews');
    right.setAttribute('aria-label', 'Next reviews');

    function updateArrows() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth - 2;
      left.setAttribute('aria-disabled', scroller.scrollLeft <= 2 ? 'true' : 'false');
      right.setAttribute('aria-disabled', scroller.scrollLeft >= maxScroll ? 'true' : 'false');
    }

    function move(direction) {
      scroller.scrollBy({
        left: direction * Math.max(280, Math.round(scroller.clientWidth * 0.85)),
        behavior: 'smooth'
      });
      window.setTimeout(updateArrows, 350);
    }

    function handleKey(event, direction) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      move(direction);
    }

    left.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      move(-1);
    }, true);
    right.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      move(1);
    }, true);
    left.addEventListener('keydown', function (event) { handleKey(event, -1); });
    right.addEventListener('keydown', function (event) { handleKey(event, 1); });
    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }, 200);
})();
